import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { syncHistory } from 'react-router-redux';
import { browserHistory } from 'react-router';
import { queryMiddleware, actionTypes as QUERY_ACTION_TYPES } from 'redux-query';
import REQUERY_ACTION_TYPES from './requery/actionTypes';
import auth from './auth';
import { USER_ACTIONS } from './reducers/user';
import getRootReducer from './reducers';
import { getEntities, getQueries } from './selectors';
import {
    generateLineUp as generateLineUpMiddleware,
    postLineUp as postLineUpMiddleware,
} from './grid-maker-tool-page/middlewares';

const authMiddleware = store => next => action => {
    next(action);
    if (
        (action.type === QUERY_ACTION_TYPES.REQUEST_FAILURE || action.type === REQUERY_ACTION_TYPES.REQUEST_FAILURE) &&
        action.status === 401
    ) {
        auth.logout();
        store.dispatch({ type: USER_ACTIONS.LOGOUT });
    }
};

const reduxRouterMiddleware = syncHistory(browserHistory);

export const getStore = (initialState = {}) => {
    const middleware = [
        thunk,
        queryMiddleware(getQueries, getEntities),
        authMiddleware,
        reduxRouterMiddleware,
        generateLineUpMiddleware,
        postLineUpMiddleware,
    ];
    const enhancers = [];

    let composeEnhancers = compose;

    if (process.env.NODE_ENV === 'dev') {
        const composeWithDevToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
        if (typeof composeWithDevToolsExtension === 'function') {
            composeEnhancers = composeWithDevToolsExtension;
        }
    }
    const store = createStore(
        getRootReducer,
        initialState,
        composeEnhancers(applyMiddleware(...middleware), ...enhancers),
    );
    return store;
};

export default getStore();



/** WEBPACK FOOTER **
 ** ../src/dash/front/createStore.js
 **/